import { ServiceFetch } from '../service-fetch'

export default class CompanyEmployeeInfoModel extends ServiceFetch {
    getCompanyEmployeeInfo = (data) => this.authFetch({
        url: 'company-employee-info/getCompanyEmployeeInfo',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateCompanyEmployeeInfoBy = (data) => this.authFetch({
        url: 'company-employee-info/updateCompanyEmployeeInfoBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}